module.exports = __webpack_public_path__ + "img/gallery-img-4.a5dc2e59.jpg";